import { IncidentGracePeriod } from "../incidents/incident.models";

export enum SafetyRatingTypeEnum {
    FullScore = -3,
    Partial = -2,
    NA = -1,
    Score0 = 0,
    Score1 = 1,
    Score2 = 2
}

export enum RightshipEexiComplianceTypeEnum {
    Eexi = 1,
    Eedi = 2,
    Evdi = 3,
}

export interface VesselHeaderModel {
    isVerified: boolean;
    isSanctioned: boolean;
    isFlagFake: boolean;
    rsInspectionRequired: boolean;
    emissionsRating: string;
    emissionsRatingPlus: boolean;
    vesselType: string;
    vesselStatus: string;
    vesselStatusCode: string;
    isInGeoPoliticalZone: boolean;
    hasGeopoliticalConflict: boolean;
    dwt: number;
    maxDwt: number;
    flag: string;
    starRating: number;
    dateOfBuild: Date;
    lastRightShipInspectionId: number;
    requestedDateOfInspection: Date;
    rightShipInspectionExpiryDate: Date;
    reasonForInspection: string;
    reasonForRequiredInspectionBanner: string;
    actualDateOfInspection: Date;
    vesselId: number;
    entityId: number;
    safetyRatingType: number;
    notInService: boolean;
    rightShipInspectionStatus: string;
    requiresRightShipInspection: boolean;
    classSocieties: ClassSocietyClientModel[];
    banners: VesselHeaderBannerModel[];
    age: number;
    daysRemainingMinutely: number;
    daysRemaining: number;
    daysToAgeRequirement: number;
    inspectionState: number;
    inspectionRequired: boolean;
    imo: string;
    eni: string;
    vin: string;
    label: string;
    identifier: string;
    vesselName: string;
    officialNumber: string;
    hasPendingInspection: boolean;
    rightShipInspectionGradeCode: string;
    rightShipInspectionGradeToolTipText: string;
    rightShipInspectionGrade: string;
    useMobileInspectionWorkflow: boolean;
    isRightShipInspectionStatusAcceptable: boolean;
    isEexiCompliant: boolean;
    eexiComplianceTypeId: RightshipEexiComplianceTypeEnum;
    hideSafetyScore: boolean;
    docCompanyName?: string;
    hasCompletedVesselHealthCheck: boolean;
    lastVhcPerformedDate: Date;
    incidentGracePeriods: IncidentGracePeriod[]; 
    lastestCiiYear?: number;
    ciiRating: string;
    inspectionRequiredSinceDate: Date;
}

export interface ClassSocietyClientModel {
    classId: number;
    classCode: string;
    className: string;
    classUrl: string;
    classHistoryId: number;
}

export interface VesselHeaderBannerModel {
    response: GetBannerResponse[];
    internalName: string;
    displayName: string;
}

export interface GetBannerResponse {
    businessUnit: string;
    internalName: string;
    displayName: string;
    companyName: string;
    countryName: string;
    listName: string;
    listId: number;
    description: string;
    isCompanyList: boolean;
    isCountrySanctioned: boolean;
    isVesselFlagSanctioned: boolean;
    bocCountrySanctioned: boolean;
    cmcCountrySanctioned: boolean;
    cocCountrySanctioned: boolean;
    docCountrySanctioned: boolean;
    rocCountrySanctioned: boolean;
    tmcCountrySanctioned: boolean;
    isFlagFake: boolean;
}